<template>
  <div class="recruiter ico-browser font_Montserrat v3_color_black_knight px-3">
    <div>
      <b-card no-body class="mt-2 v3_box_teal">
        <b-card-body class="v3_box_teal_body">
          <div class="box-body-wrapper flex-column p-4">
            <b class="v3_color_teal"> Find Your Perfect Candidates</b>
            <p />
            <b-row class="w-100 mt-3">
              <b-col sm="12" md="4" lg="3" class="">
                <recruiter-ico-criteria
                  :loading="!criteriaItems.length"
                  :criteria-items="criteriaItems"
                >
                  <template slot-scope="{ items, getLabel }">
                    <div
                      class="d-flex flex-column justify-content-stretch mt-3"
                    >
                      <template v-for="item in items">
                        <div
                          :id="`criteria-btn-${item.id}`"
                          :key="`criteria-btn-${item.id}`"
                          :set="(disabled = !isSpecialtySubspecialtySpecified &&
                          item.type !== JOB_QUESTION_TYPES.SPECIALTY)"
                          tabindex="0"
                          class="d-flex flex-column justify-content-stretch"
                        >
                          <b-button
                            variant="v3_teal_outline text-break"
                            :class="[
                              'mb-2',
                              {
                                active: selectedJobQuestionId === item.id,
                              },
                            ]"
                            :disabled="disabled"
                            @click="onChangeCriteria(item)"
                          >
                            {{ getLabel(item) }}
                          </b-button>
                        </div>
                        <b-tooltip
                          v-if="disabled"
                          :key="`criteria-tooltip-${item.id}`"
                          :target="`criteria-btn-${item.id}`"
                          triggers="hover"
                        >
                          This criteria is not active until a specialty /
                          sub-specialty is chosen.
                        </b-tooltip>
                      </template>
                    </div>
                  </template>
                </recruiter-ico-criteria>
              </b-col>
              <b-col sm="12" md="8" lg="6" class="">
                <div class="border_1 border_light_teal h-100 w-100 p-3">
                  <template v-if="selectedJobQuestion">
                    <recruiter-ico-criteria-detail
                      :job-question="selectedJobQuestion"
                      :loading-detail="loadingDetail"
                      @set-criteria-value="onSetCriteriaValue"
                      :filter-user-count="true"
                    />
                  </template>
                  <template v-else>
                    <div class="d-flex align-items-center mt-4 w-100">
                      <div
                        class="text-center v3_color_teal d-flex flex-column justify-content-center w-100"
                      >
                        <span>
                            1. Enter job opportunity criteria.
                          </span>
                          <span>
                            2. See matching candidates.
                          </span>
                          <span>
                            3. Connect only when you're satisfied.
                          </span>
                      </div>
                    </div>
                  </template>
                </div>
              </b-col>
              <b-col sm="12" md="12" lg="3" class="mt-md-2 mt-lg-0">
                <div
                  class="border_1 border_light_teal h-100 w-100 pt-1 pb-4 px-2"
                >
                  <b-row>
                    <b-col sm="12" md="6" lg="12">
                      <recruiter-ico-criteria-results
                        :criteria-items="criteriaItems"
                      />
                    </b-col>
                    <b-col sm="12" md="6" lg="12" class="mt-3 mt-md-0 mt-lg-3">
                      <div
                        class="border_1 border_light_teal h-100 w-100 pt-1 pb-4 px-2"
                      >
                        <recruiter-ico-matching
                          :value="matchingValue"
                          :loading="loadingMatching"
                        />
                        <div class="mt-3 d-flex justify-content-center">
                          <b-button
                            v-if="jobOffer"
                            variant="v3_teal_outline"
                            @click="onAfterPaidContinue"
                          >
                            Continue
                          </b-button>
                          <!-- <b-button
                            v-else
                            variant="v3_teal_outline"
                            @click="showPurchaseModal"
                          >
                            Purchase Connect
                          </b-button> -->
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>

            <p class="font_size_1125rem font-weight-bold v3_color_teal mt-4">
              Let candidates know their ideal job is waiting for them.
            </p>
            <b-button variant="v3_teal_outline">
              Post this Job Opportunity
            </b-button>
          </div>
        </b-card-body>
      </b-card>
    </div>
    <purchase-modal
      v-if="isPurchaseModalVisible"
      v-model="isPurchaseModalVisible"
      @cancel="isPurchaseModalVisible = false"
      @job-offer-paid="onJobOfferPaid"
    />
  </div>
</template>

<script>
import Api from '@/providers/Api';
import RecruiterIcoCriteria from '@/components/recruiter/ico/criteria/RecruiterIcoCriteria';
import RecruiterIcoMatching from '@/components/recruiter/ico/matching/RecruiterIcoMatching';
import RecruiterIcoCriteriaDetail from '@/components/recruiter/ico/criteria/RecruiterIcoCriteriaDetail';
import RecruiterIcoCriteriaResults from '@/components/recruiter/ico/criteria/RecruiterIcoCriteriaResults';
import PurchaseModal from '@/components/recruiter/payment/PurchaseModal';
import { createAdditionalCriteriaItems } from '@/helpers/recruiter/IcoBrowser/criteriaHelper';
import { COOKIES, JOB_QUESTION_TYPES } from '@/store';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';

export default {
  name: 'IcoReviewDetails',
  components: {
    RecruiterIcoCriteriaDetail,
    RecruiterIcoMatching,
    RecruiterIcoCriteria,
    RecruiterIcoCriteriaResults,
    PurchaseModal,
  },
  data: function () {
    return {
      criteriaItems: [],
      selectedJobQuestion: null,
      loadingDetail: false,
      matchingValue: '-',
      loadingMatching: false,
      isPurchaseModalVisible: false,
      jobOffer: null,
    };
  },
  created: function () {
    this.getData();
  },
  mounted: function () {
    if (this.$cookies.isKey(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)) {
      this.isPurchaseModalVisible = true;
    }
  },
  computed: {
    isSpecialtySubspecialtySpecified: function () {
      const specialtyCriteria = this.criteriaItems.find(
        (item) => item.type === JOB_QUESTION_TYPES.SPECIALTY
      );
      return (
        specialtyCriteria &&
        specialtyCriteria.value &&
        specialtyCriteria.value.subspecialtyId
      );
    },
    JOB_QUESTION_TYPES: function () {
      return JOB_QUESTION_TYPES;
    },
    selectedJobQuestionId: function () {
      return this.selectedJobQuestion ? this.selectedJobQuestion.id : null;
    },
  },
  methods: {
    getData: async function () {
      const additionalCriteria = createAdditionalCriteriaItems();
      const jobQuestions = await Api.getJobQuestionsForIcoBrowser();
      this.criteriaItems = [...additionalCriteria, ...jobQuestions];

      if (this.$cookies.isKey(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)) {
        const values = JSON.parse(
          this.$cookies.get(COOKIES.GUEST_ICO_BROWSER_CRITERIA_ITEM_VALUES)
        );
        values.forEach(({ id, type, value }) => {
          if (!value) return;
          const index = this.criteriaItems.findIndex((i) => {
            return (
              i.id === id ||
              (i.type === JOB_QUESTION_TYPES.SPECIALTY &&
                type === JOB_QUESTION_TYPES.SPECIALTY) ||
              (i.type === JOB_QUESTION_TYPES.LOCATION &&
                type === JOB_QUESTION_TYPES.LOCATION)
            );
          });
          if (index === -1) return;
          this.$set(this.criteriaItems[index], 'value', { ...value });
        });
        this.updateMatching();
      }
    },
    onSetCriteriaValue: function (params) {
      const index = this.criteriaItems.findIndex((i) => {
        return i.id === this.selectedJobQuestion.id;
      });
      this.$set(this.criteriaItems[index], 'value', { ...params });
      this.$nextTick(() => {
        this.updateMatching();
      });
    },
    onChangeCriteria: async function (jobQuestion) {
      const jqIndex = this.criteriaItems.findIndex(
        (jq) => jq.id === jobQuestion.id
      );
      this.selectedJobQuestion = this.criteriaItems[jqIndex];
    },
    updateMatching: async function () {
      this.loadingMatching = true;
      try {
        this.matchingValue = await Api.findNumberOfMatches(this.criteriaItems,0);
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.loadingMatching = false;
      }
    },
    showPurchaseModal: function () {
      this.isPurchaseModalVisible = true;
    },
    onJobOfferPaid: function (jobOffer) {
      this.isPurchaseModalVisible = false;
      this.jobOffer = jobOffer;
    },
    onAfterPaidContinue: function () {
      this.$router.push(`/recruiter/edit-job-offer/${this.jobOffer.id}`);
    },
  },
};
</script>

<style scoped>
@media only screen and (min-width: 320px) and (max-width:768px){
  .box-body-wrapper{
    padding: 1rem;
    justify-content: center;
  }
}
</style>

<style lang="scss" scoped>
@import '../../../../sass/variables_mixins.scss';

.recruiter {
  font-family: $phairify_font_montserrat;
  margin-top:25px !important;
}
</style>
